import { Component, ViewChild, NgZone } from '@angular/core'
import {
  IonicPage,
  Platform,
  LoadingController,
  ModalController,
  Modal,
  ModalOptions,
  AlertController
} from 'ionic-angular'
import $ from 'jquery'
import { Camera } from '@ionic-native/camera'
import {
  CameraPreview,
  CameraPreviewOptions
} from '@ionic-native/camera-preview'
import { InAppBrowser } from '@ionic-native/in-app-browser'
import * as _ from 'underscore/underscore'
import { Hammer } from 'ionic-angular/gestures/hammer'
import { Screenshot } from '@ionic-native/screenshot/ngx'
import { PhotoLibrary } from '@ionic-native/photo-library'
import { SocialSharing } from '@ionic-native/social-sharing'
import { ScreenOrientation } from '@ionic-native/screen-orientation'
import { TranslateService } from '@ngx-translate/core'
import { FabContainer } from 'ionic-angular'
import { global } from '../../app/global'
import { Storage } from '@ionic/storage'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import firebase from 'firebase/app'
import 'firebase/firestore'
import domtoimage from 'dom-to-image-even-more'
import axios from 'axios'
import { Base64 } from '@ionic-native/base64';

@IonicPage()
@Component({
  selector: 'page-main',
  templateUrl: 'main.html'
})
export class MainPage {
  Global: any = global

  APP_STATE_NO_PICTURE = 0
  APP_STATE_TAKING_PICTURE = 1
  APP_STATE_DRAWING = 2
  APP_STATE_MATERIAL = 3
  APP_STATE_SAVING = 4
  APP_STATE_GALLERY_OPTIONS = 5
  APP_PREDEFINED_GALLERY = 6
  APP_CATEGORY_SET = 7
  appState = this.APP_STATE_NO_PICTURE
  category = ''
  logoImages = {
    en: "assets/imgs/logoEN.png",
    es: 'assets/imgs/logoES.png',
    fr: 'assets/imgs/logoFR.png',
    pt: 'assets/imgs/logoPT.png',
    de: 'assets/imgs/logoDE.png'
  }

  btnCameraDisabled = false

  showControls = true

  defaultLan = 'es'

  perspectiveIconShowed = false
  zoomIconShowed = false
  brightnessIconShowed = false
  clickIconShowed = false

  cameraPictureBase64 = ''
  cameraPictureBase64Portrait = ''
  cameraPictureBase64Landscape = ''
  currentOrientation = ''
  currentMenuOrientation = ''

  layerHistory = {}
  productsList = []

  showTutorial = false

  pSize

  fuga = 50
  screen_zoom = 100

  zones = {}
  currentZone
  currentAction
  currentInclude

  indicatorX = 0
  indicatorY = 0

  hammer: any = Hammer
  isZooming = false
  isTapping = false
  pointToMove: any = null

  cameraOrientation = 'landscape'

  openEstimateModal: boolean = false

  clickIconTimeout: number

  myForm: FormGroup
  submitted = false

  @ViewChild('fab') fab: FabContainer
  @ViewChild('fableft') fableft: FabContainer

  constructor (
    private platform: Platform,
    private camera: Camera,
    private cameraPreview: CameraPreview,
    private plt: Platform,
    public loadingCtrl: LoadingController,
    private modal: ModalController,
    private alertCtrl: AlertController,
    private screenshot: Screenshot,
    private photoLibrary: PhotoLibrary,
    private socialSharing: SocialSharing,
    private screenOrientation: ScreenOrientation,
    private translate: TranslateService,
    private iab: InAppBrowser,
    private storage: Storage,
    private base64: Base64,
    public formBuilder: FormBuilder,
    private zone: NgZone
  ) {
    this.initialValues()
  }
  ionViewDidLoad () {
    this.defaultLan = this.platform.getQueryParam('lang')
    this.dragAndDrop()
    this.initialConfig()
    this.currentOrientation = this.screenOrientation.type
    this.currentMenuOrientation = this.screenOrientation.type
    this.screenOrientation.onChange().subscribe(() => {
      if(this.screenOrientation.type.includes('landscape')){
        this.currentOrientation = this.screenOrientation.type
        this.zone.run(() => {
          console.log('force update the screen');
        })
      }
      this.currentMenuOrientation = this.screenOrientation.type
    })
  }

  // Drag and drop Image
  dragAndDrop () {
    var el = document.querySelector('body')
    el.addEventListener(
      'dragenter',
      e => {
        e.stopPropagation()
        e.preventDefault()
      },
      false
    )
    el.addEventListener(
      'dragover',
      e => {
        e.stopPropagation()
        e.preventDefault()
      },
      false
    )
    el.addEventListener(
      'dragleave',
      e => {
        e.stopPropagation()
        e.preventDefault()
      },
      false
    )
    el.addEventListener(
      'drop',
      async e => {
        const toBase64 = file =>
          new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
          })
        e.stopPropagation()
        e.preventDefault()
        if (e.dataTransfer.files[0]) {
          const image = await toBase64(e.dataTransfer.files[0])
          $('#zone_' + this.currentZone + ' .points_path .material').css(
            'background-image',
            'url(' + image + ')'
          )
        }

        return false
      },
      false
    )
  }

  async showEstimateModal () {
    if (!this.plt.is('core')) {
      await this.screenOrientation.lock(
        this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY
      )
    }
    this.openEstimateModal = true
  }

  async hideEstimateModal () {
    this.openEstimateModal = false
    if (!this.plt.is('core')) {
      if(this.currentMenuOrientation === 'landscape-primary' ){
        if(this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY
          )
        } else {
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY
          )
        }
        if(!this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY
          )
        }
      }
      if(this.currentMenuOrientation === 'landscape-secondary'){
        if(this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY
          )
        } else {
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY
          )
        }
        if(!this.plt.is('ios')){
          console.log('THIS SHOULD RUN')
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY
          )
        }
      }
      if(this.currentMenuOrientation === 'portrait-primary'){
        if(this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.PORTRAIT_SECONDARY
          )
        }else {
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY
          )
        }
        if(!this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY
          )
        }
        
      }
      if( this.currentMenuOrientation === 'portrait-secondary'){
        if(this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY
          )
        }else {
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.PORTRAIT_SECONDARY
          )
        }
        if(!this.plt.is('ios')){
          await this.screenOrientation.lock(
            this.screenOrientation.ORIENTATIONS.PORTRAIT_SECONDARY
          )
        }
      }
    }
    
  }

  showGalleryOptions () {
    this.appState = this.APP_STATE_GALLERY_OPTIONS
  }

  hideGalleryOptions () {
    this.appState = this.APP_STATE_NO_PICTURE
  }

  showPredefinedGallery () {
    this.appState = this.APP_PREDEFINED_GALLERY
  }

  hidePredefinedGallery () {
    this.appState = this.APP_STATE_GALLERY_OPTIONS
  }

  hideCategory () {
    this.appState = this.APP_PREDEFINED_GALLERY
  }

  setCategory (category: string) {
    this.appState = this.APP_CATEGORY_SET
    this.category = category
  }

  logout () {
    firebase.auth().signOut()
  }

  get errorCtr () {
    return this.myForm.controls
  }

  async onSubmit () {
    this.submitted = true
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('saving_image')
    })
    if (!this.myForm.valid) {
      return false
    } else {
      $('#fab_box').css('opacity', '0')
      $('#show_button').css('opacity', '0')
      this.hideEstimateModal()
      loading.present()
      setTimeout(async () => {
        const savingImage = document.getElementById('image_to_save')
        const url = await domtoimage.toPng(savingImage)
        const response = await axios.post(
          'https://cupastone-distributor-map.vercel.app/api/v1/sendMail',
          {
            name: this.myForm.value.name,
            surname: this.myForm.value.surname,
            zipCode: this.myForm.value.zipCode,
            city: this.myForm.value.city,
            area: this.myForm.value.area,
            email: this.myForm.value.email,
            phoneNumber: this.myForm.value.phoneNumber,
            message: this.myForm.value.message,
            imageURL: url,
            materials: this.productsList
          }
        )
        $('#fab_box').css('opacity', '1')
        $('#show_button').css('opacity', '1')
        loading.dismiss()
        this.myForm.reset()
        this.submitted = false
        let alert = this.alertCtrl.create()
        if (response.data.result === 'success') {
          alert.setTitle(this.translate.instant('form_success'))
          alert.addButton('OK')
        } else {
          alert.setTitle(this.translate.instant('form_error'))
          alert.addButton('OK')
        }
        alert.present()
      }, 2000)
    }
  }

  initialConfig () {
    // FORM VALIDATION
    this.myForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      zipCode: ['', [Validators.required]],
      city: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      area: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')
        ]
      ],
      message: ['']
    })

    var that = this
    this.plt.ready().then(readySource => {
      var isPanning = false
      var isScrolling = false
      var isDraggingPoint = false
      var myElement = document.getElementsByClassName('gesture_listener')[0]

      var mc = this.hammer(myElement, { direction: this.hammer.DIRECTION_ALL })
      mc.get('pan').set({ direction: this.hammer.DIRECTION_ALL })

      mc.on('panleft panright panup pandown', function (ev) {
        isScrolling = true

        if (
          that.currentZone != 0 &&
          that.zones['zone_' + that.currentZone]['background'] != ''
        ) {
          isPanning = true

          if (!isDraggingPoint) {
            if (ev.type == 'panright') {
              if (that.currentAction == 'perspective') {
                if (that.zones['zone_' + that.currentZone].type == 'wall')
                  that.perspectiveRight()
                else that.fugaRight()
              }
            } else if (ev.type == 'panleft') {
              if (that.currentAction == 'perspective') {
                if (that.zones['zone_' + that.currentZone].type == 'wall')
                  that.perspectiveLeft()
                else that.fugaLeft()
              }
            } else if (ev.type == 'panup') {
              if (that.currentAction == 'perspective') {
                if (that.zones['zone_' + that.currentZone].type == 'wall')
                  that.fugaUp()
                else that.perspectiveUp()
              } else if (that.currentAction == 'zoom') {
                that.zoomIn()
              } else if (that.currentAction == 'brightness') {
                that.brightnessUp()
              }
            } else if (ev.type == 'pandown') {
              if (that.currentAction == 'perspective') {
                if (that.zones['zone_' + that.currentZone].type == 'wall')
                  that.fugaDown()
                else that.perspectiveDown()
              } else if (that.currentAction == 'zoom') {
                that.zoomOut()
              } else if (that.currentAction == 'brightness') {
                that.brightnessDown()
              }
            }
          }
        } else {
          if (!isDraggingPoint) {
            const bg = document.getElementsByClassName('scroll-content')[2]
            if (bg) {
              if (ev.type == 'panright') {
                bg.scrollLeft -= Math.floor(ev.deltaX / 20)
              } else if (ev.type == 'panleft') {
                bg.scrollLeft -= Math.floor(ev.deltaX / 20)
              } else if (ev.type == 'panup') {
                bg.scrollTop -= Math.floor(ev.deltaY / 20)
              } else if (ev.type == 'pandown') {
                bg.scrollTop -= Math.floor(ev.deltaY / 20)
              }
            }
          }
        }
      })

      $('.gesture_listener').on('touchstart mousedown', '.dot', function (e) {
        isDraggingPoint = true
        that.pointToMove = $(this)
      })

      $('.gesture_listener').on('touchstart mousedown', function (e) {
        if (
          that.appState == that.APP_STATE_MATERIAL &&
          e.target.localName != 'ion-icon' &&
          e.target.localName != 'span' &&
          e.target.localName != 'button' &&
          e.target.localName != 'img'
        ) {
          that.isTapping = true
          let pageX = 0
          let pageY = 0
          if (!that.plt.is('cordova')) {
            pageX = e.pageX
            pageY = e.pageY
          } else {
            pageX = e.changedTouches[0].pageX
            pageY = e.changedTouches[0].pageY
          }
          that.indicatorX = (pageX * 100) / window.innerWidth
          that.indicatorY = (pageY * 100) / window.innerHeight
        }
      })

      $('.gesture_listener').on(
        'touchmove mousemove',
        '.drawing_area',
        function (e) {
          if (isDraggingPoint) {
            $('ion-fab, .overlapp_logo').css({
              display: 'none'
            })
            $('.scroll-content').css({
              overflow: 'hidden',
              height: '100%'
            })

            var pathType = $(that.pointToMove).data('pathType')
            var index = $(that.pointToMove).data('index')

            var posX = $('.points').offset().left,
              posY = $('.points').offset().top
            let pageX = 0
            let pageY = 0
            if (!that.plt.is('cordova')) {
              pageX = e.pageX
              pageY = e.pageY
            } else {
              pageX = e.changedTouches[0].pageX
              pageY = e.changedTouches[0].pageY
            }
            var clipX = ((pageX - posX) * 100) / $('.points').outerWidth()
            var clipY = ((pageY - posY) * 100) / $('.points').outerHeight()

            that.zones['zone_' + that.currentZone][pathType][index] = {
              x: clipX,
              y: clipY
            }

            that.drawPoints(clipX, clipY)
          }
        }
      )

      $('.gesture_listener').on('touchend mouseup', '.drawing_area', function (
        e
      ) {
        that.isTapping = false
        if (!that.isZooming) {
          if (
            that.currentZone != 0 &&
            that.zones['zone_' + that.currentZone]['background'] == ''
          ) {
            if (
              !isDraggingPoint &&
              !isPanning &&
              !that.isZooming &&
              !isScrolling
            ) {
              var posX = $('.points').offset().left,
                posY = $('.points').offset().top
              let pageX = 0
              let pageY = 0
              if (!that.plt.is('cordova')) {
                pageX = e.pageX
                pageY = e.pageY
              } else {
                pageX = e.changedTouches[0].pageX
                pageY = e.changedTouches[0].pageY
              }
              var clipX = ((pageX - posX) * 100) / $('.points').outerWidth()
              var clipY = ((pageY - posY) * 100) / $('.points').outerHeight()
              that.drawPoints(clipX, clipY)
            } else {
              isDraggingPoint = false
              $('ion-fab, .overlapp_logo').css({
                display: 'initial'
              })
            }
            isPanning = false
            isScrolling = false
          }
        }
      })

      $('.gesture_listener').on(
        'touchend mouseup',
        '.tutorial_layer',
        function (e) {
          that.showTutorial = false
        }
      )
    })
  }

  getIndicatorPosition () {
    return {
      top: this.indicatorY - 12 + '%',
      left: this.indicatorX - 22 + '%'
    }
  }

  getXArrowText () {
    var text = ''
    var zoneType = this.zones['zone_' + this.currentZone]['type']
    if (this.currentAction == 'perspective') {
      if (zoneType == 'wall') text = this.translate.instant('perspective')
      else if (zoneType == 'floor')
        text = this.translate.instant('vanishing_point')
    } else if (this.currentAction == 'zoom') text = ''
    else if (this.currentAction == 'brightness') text = ''
    return text
  }

  getYArrowText () {
    var text = ''
    var zoneType = this.zones['zone_' + this.currentZone]['type']
    if (this.currentAction == 'perspective') {
      if (zoneType == 'wall') text = this.translate.instant('vanishing_point')
      else if (zoneType == 'floor') text = this.translate.instant('perspective')
    } else if (this.currentAction == 'zoom') text = 'Zoom'
    else if (this.currentAction == 'brightness')
      text = this.translate.instant('brightness')
    return text
  }

  toggleClassFab () {
    $('div.new_fab_container').toggleClass('collapsed')
  }

  /* CAMERA */

  getOrientation () {
    if (this.screenOrientation.type.includes('portrait')) return 'portrait'
    else return 'landscape'
  }

  getCameraOrientation () {
    if (this.cameraOrientation == 'portrait') return 'portrait'
    else return 'landscape'
  }

  changeCameraOrientation () {
    this.showTutorial = false

    if (this.cameraOrientation == 'portrait')
      this.cameraOrientation = 'landscape'
    else this.cameraOrientation = 'portrait'
  }


  changeOrientation () {
    if (this.plt.is('cordova')) {
      $('html').css('opacity', '0')
      setTimeout(() => {
        if (this.screenOrientation.type.includes('portrait')) {
          this.screenOrientation
            .lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY)
            .then(() => {
              this.cameraPictureBase64 = this.cameraPictureBase64Landscape
              setTimeout(() => {
                $('html').css('opacity', '1')
              }, 100)
            })
            .catch()
        } else {
          this.screenOrientation
            .lock(this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY)
            .then(() => {
              this.cameraPictureBase64 = this.cameraPictureBase64Portrait
              setTimeout(() => {
                $('html').css('opacity', '1')
              }, 100)
            })
        }
      }, 500)
    }
  }

  changeBackgroundColor = (className, color) => {
    Array.from(document.querySelectorAll(className)).forEach(el => {
      el.style.transition = 'background-color 0.5s linear 0s'
      el.style.backgroundColor = color
    })
  }

  async openCamera () {
    var that = this
    const cameraPreviewOpts: CameraPreviewOptions = {
      x: 0,
      y: 0,
      width: window.innerWidth,
      height: window.innerHeight,
      camera: 'rear',
      tapPhoto: false,
      previewDrag: false,
      toBack: true,
      alpha: 1
    }

    const loader = this.loadingCtrl.create({
      content: 'Loading camera...'
    })
    
    loader.present()

    this.cameraPreview.startCamera(cameraPreviewOpts).then(
      res => {
        setTimeout(() => {
          that.storage.get('tutorial_shown').then(tutorial_shown => {
            that.showTutorial = false
            // if (!tutorial_shown) {
            //   that.showTutorial = false
            //   that.storage.set('tutorial_shown', true)
            // }
          })
        }, 1000)

        that.cameraPreview
          .show()
          .then(() => {
            loader.dismiss()
            that.changeBackgroundColor('.app-root', 'transparent')
            $('.main_background_image').css('opacity', '0')
            that.appState = that.APP_STATE_TAKING_PICTURE
          })
          .catch(err2 => {
            loader.dismiss()
            that.changeBackgroundColor('.app-root', 'initial')
            that.appState = that.APP_STATE_NO_PICTURE
            console.log(err2)
          })
      },
      err => {
        loader.dismiss()
        that.changeBackgroundColor('.app-root', 'initial')
        that.appState = that.APP_STATE_NO_PICTURE
        console.log(err)
      }
    )
  }

  takePicture () {
    var that = this

    that.changeBackgroundColor('.app-root', 'initial')

    this.btnCameraDisabled = true

    let loading = this.loadingCtrl.create({
      content: this.translate.instant('import_image')
    })

    loading.present()

    this.cameraPreview.takePicture().then(
      imageData => {
        that.cameraPictureBase64Landscape =
          'data:image/jpeg;base64,' + imageData
        that.cameraPictureBase64 = 'data:image/jpeg;base64,' + imageData

        var degrees = 90
        if (that.plt.is('ios')) degrees = 90

        that.rotateImage(imageData, degrees).then(i => {
          that.newZone()
          that.appState = that.APP_STATE_DRAWING
          that.cameraPictureBase64Portrait = i
          loading.dismiss()

          that.storage
            .get('slides_tutorial_shown')
            .then(slides_tutorial_shown => {
              if (!slides_tutorial_shown) {
                that.openTutorial()
                that.storage.set('slides_tutorial_shown', true)
              }
            })

          setTimeout(() => {
            let rotating = that.loadingCtrl.create({
              content: that.translate.instant('rotate_image')
            })
            const loader = that.loadingCtrl.create({
              content: 'Closing camera...'
            })

            loader.present()
            // Whole block to hide and stop the camera
            that.cameraPreview
              .hide()
              .then(() => {
                that.cameraPreview
                  .stopCamera()
                  .then(() => {
                    loader.dismiss()
                  })
                  .catch(err => {
                    loader.dismiss()
                    console.log(err)
                  })
              })
              .catch(err2 => {
                console.log(err2)
                loader.dismiss()
              })
            // ** until here

            if (that.cameraOrientation == 'portrait') {
              rotating.present()
            }
            setTimeout(() => {
              if (that.cameraOrientation == 'portrait') {
                that.changeOrientation()
                rotating.dismiss()
              }
            }, 800)
          }, 1000)
        })
      },
      err => {
        loading.dismiss()
        that.appState = that.APP_STATE_NO_PICTURE
        console.log(err)
      }
    )
  }

  rotateImage (imageData, degrees): Promise<string> {
    return new Promise((resolve, reject) => {
      let canvas = document.createElement('canvas')
      let canvasContext = canvas.getContext('2d')
      let image = new Image()

      image.src = 'data:image/jpeg;base64,' + imageData

      image.onload = function () {
        if ((degrees / 90) % 2 === 0) {
          canvas.width = image.width
          canvas.height = image.height
        } else {
          canvas.width = image.height
          canvas.height = image.width
        }

        switch (degrees) {
          case 90:
            canvasContext.translate(canvas.width, 0)
            break
          case 180:
            canvasContext.translate(canvas.width, canvas.height)
            break
          case 270:
            canvasContext.translate(0, canvas.height)
            break
        }

        canvasContext.rotate((degrees * Math.PI) / 180)
        canvasContext.drawImage(image, 0, 0)
        resolve(canvas.toDataURL())
      }
    })
  }

  newPicture () {
    let alert = this.alertCtrl.create()
    alert.setTitle(this.translate.instant('new_photo_question'))

    alert.addButton(this.translate.instant('cancel'))
    alert.addButton({
      text: this.translate.instant('agree'),
      handler: (type: any) => {
        this.perspectiveIconShowed = false
        this.zoomIconShowed = false
        this.brightnessIconShowed = false
        this.clickIconShowed = false

        if (!this.plt.is('cordova')) {
          this.btnCameraDisabled = false
          this.appState = this.APP_STATE_NO_PICTURE
          $('.main_background_image').css('opacity', '1')
          $('.background_image').css('background-image', 'none')
          this.initialValues()
        } else {
          let orientation
          if(this.currentOrientation.includes('landscape-primary')){
            orientation = this.plt.is('ios') ? this.screenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY : this.screenOrientation.ORIENTATIONS
            .LANDSCAPE_PRIMARY
          } else if(this.currentOrientation.includes('landscape-secondary')){
            orientation = this.plt.is('ios') ? this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY : this.screenOrientation.ORIENTATIONS
            .LANDSCAPE_SECONDARY
          } else if(this.currentOrientation.includes('portrait-primary')){
            orientation = this.plt.is('ios') ? this.screenOrientation.ORIENTATIONS.PORTRAIT_SECONDARY : this.screenOrientation.ORIENTATIONS
            .PORTRAIT_PRIMARY
          } else {
            orientation = this.plt.is('ios') ? this.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY : this.screenOrientation.ORIENTATIONS
            .PORTRAIT_SECONDARY
          }
          

          this.screenOrientation.lock(orientation).then(() => {
            this.btnCameraDisabled = false
            this.appState = this.APP_STATE_NO_PICTURE
            $('.main_background_image').css('opacity', '1')
            $('.background_image').css('background-image', 'none')
            this.initialValues()
          })
        }
      }
    })
    alert.present()
  }

  cancelTakePicture () {
    $('.main_background_image').css('opacity', '1')
    this.appState = this.APP_STATE_NO_PICTURE

    const loader = this.loadingCtrl.create({
      content: 'Closing camera...'
    })

    loader.present()

    this.cameraPreview
      .hide()
      .then(() => {
        this.cameraPreview
          .stopCamera()
          .then(() => {
            loader.dismiss()
          })
          .catch(err => {
            loader.dismiss()
            console.log(err)
          })
      })
      .catch(err2 => {
        console.log(err2)
        loader.dismiss()
      })
  }

  async setPredefinedPhoto (data) {
    const toBase64 = file =>
      new Promise((resolve, reject) => {
        let reader
        try{
          reader = new FileReader()
          setTimeout(() => {
            reader.abort()
            reject()
          }, 5000)
          try{
            reader.readAsDataURL(file)
          }catch(e){
            console.log('Error reading',e)
            reject(e)
          }
          
        }catch(e){
          console.log(e)
          reject(e)
        }
        
        reader.onload = () =>{
           resolve(reader.result)
          }
        reader.onerror = error => {
          reject(error)
        }
      })
    
     

    const imageData = await fetch(data)
    // @ts-ignore
    // const parsedImageData = new Response(imageData.body)
    const file = await imageData.blob()

    if (!this.plt.is('cordova')) {
      let reader = new FileReader()

      reader.onloadend = async () => {
        const imageBase64 = await toBase64(file)
        let imageData = imageBase64.toString().split(',')[1]

        this.cameraPictureBase64Landscape =
          'data:image/jpeg;base64,' + imageData
        this.cameraPictureBase64 = 'data:image/jpeg;base64,' + imageData

        this.newZone()
        this.appState = this.APP_STATE_DRAWING
      }
      reader.readAsDataURL(file)
    } else {
      let alert = this.alertCtrl.create()
      alert.setTitle(this.translate.instant('orientation'))
      alert.addInput({
        type: 'radio',
        label: this.translate.instant('horizontal'),
        value: 'landscape',
        checked: true
      })

      alert.addInput({
        type: 'radio',
        label: this.translate.instant('vertical'),
        value: 'portrait'
      })

      alert.addButton(this.translate.instant('cancel'))
      alert.addButton({
        text: this.translate.instant('agree'),
        handler: (type: any) => {
          var that = this

          //$('.main_background_image').css('opacity', '0');
          // this.appState = this.APP_STATE_TAKING_PICTURE;
          if (this.plt.is('cordova')) {
            this.cameraPreview.hide().then(() => {})
          }

          let loading = this.loadingCtrl.create({
            content: this.translate.instant('import_image')
          })
          loading.present()

          const setPhoto = async() => {
            try {
              let res
              if(this.plt.is('ios')){
                res = await this.base64.encodeFile(data)
              } else {
                res = await toBase64(file)
              }
               

              let imageData = res.toString().split(',')[1]

              this.cameraPictureBase64Landscape =
                'data:image/jpeg;base64,' + imageData
              this.cameraPictureBase64 = 'data:image/jpeg;base64,' + imageData

              if (type == 'portrait')
                this.cameraPictureBase64Portrait =
                  'data:image/jpeg;base64,' + imageData

              var degrees = 90
              if (this.plt.is('ios')) degrees = 90

              this.rotateImage(imageData, degrees).then(i => {
                this.appState = this.APP_STATE_DRAWING

                that.storage
                  .get('slides_tutorial_shown')
                  .then(slides_tutorial_shown => {
                    if (!slides_tutorial_shown) {
                      this.openTutorial()
                      that.storage.set('slides_tutorial_shown', true)
                    }
                  })

                if (type == 'portrait') this.cameraPictureBase64Landscape = i
                else this.cameraPictureBase64Portrait = i
                loading.dismiss()

                setTimeout(() => {
                  let rotating = this.loadingCtrl.create({
                    content: this.translate.instant('rotate_image')
                  })
                  if (type == 'portrait') rotating.present()
                  setTimeout(() => {
                    if (type == 'portrait') {
                      this.cameraOrientation == 'portrait'
                      this.changeOrientation()
                      rotating.dismiss()
                    }
                  }, 800)
                }, 1000)
              })
              this.newZone()
              this.currentOrientation = this.screenOrientation.type
  
              this.appState = this.APP_STATE_DRAWING
            }catch(e){
              console.log('Image error', e)
              loading.dismiss()
              this.appState = this.APP_STATE_NO_PICTURE
              const alert = this.loadingCtrl.create({
                content: this.translate.instant('error_image')
              })
              alert.present()
              setTimeout(() => {
                window.location.reload()
              },1000)
            }
          }

          setPhoto()
        }
      })
      alert.present()
    }
  }

  async openGallery () {
    const toBase64 = file =>
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })

    if (!this.plt.is('cordova')) {
      var that = this
      var input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/x-png,image/jpeg'
      input.onchange = e => {
        e.preventDefault()
        let reader = new FileReader()
        let file = (<HTMLInputElement>e.target).files[0]
        reader.onloadend = async () => {
          const imageBase64 = await toBase64(file)
          let imageData = imageBase64.toString().split(',')[1]

          this.cameraPictureBase64Landscape =
            'data:image/jpeg;base64,' + imageData
          this.cameraPictureBase64 = 'data:image/jpeg;base64,' + imageData

          this.newZone()
          this.appState = this.APP_STATE_DRAWING
        }
        reader.readAsDataURL(file)
      }
      input.click()
    } else {
      let alert = this.alertCtrl.create()
      alert.setTitle(this.translate.instant('orientation'))
      alert.addInput({
        type: 'radio',
        label: this.translate.instant('horizontal'),
        value: 'landscape',
        checked: true
      })

      alert.addInput({
        type: 'radio',
        label: this.translate.instant('vertical'),
        value: 'portrait'
      })

      alert.addButton(this.translate.instant('cancel'))
      alert.addButton({
        text: this.translate.instant('agree'),
        handler: (type: any) => {
          var that = this

          //$('.main_background_image').css('opacity', '0');
          // this.appState = this.APP_STATE_TAKING_PICTURE;
          if (this.plt.is('cordova')) {
            this.cameraPreview.hide().then(() => {})
          }

          let loading = this.loadingCtrl.create({
            content: this.translate.instant('import_image')
          })

          loading.present()

          this.camera
            .getPicture({
              quality: 80,
              destinationType: this.camera.DestinationType.DATA_URL,
              sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
              allowEdit: false,
              encodingType: this.camera.EncodingType.JPEG,
              saveToPhotoAlbum: false,
              correctOrientation: true
            })
            .then(imageData => {
              this.cameraPictureBase64Landscape =
                'data:image/jpeg;base64,' + imageData
              this.cameraPictureBase64 = 'data:image/jpeg;base64,' + imageData

              if (type == 'portrait')
                this.cameraPictureBase64Portrait =
                  'data:image/jpeg;base64,' + imageData

              var degrees = 90
              if (this.plt.is('ios')) degrees = 90

              this.rotateImage(imageData, degrees).then(i => {
                this.appState = this.APP_STATE_DRAWING

                that.storage
                  .get('slides_tutorial_shown')
                  .then(slides_tutorial_shown => {
                    if (!slides_tutorial_shown) {
                      this.openTutorial()
                      that.storage.set('slides_tutorial_shown', true)
                    }
                  })

                if (type == 'portrait') this.cameraPictureBase64Landscape = i
                else this.cameraPictureBase64Portrait = i
                loading.dismiss()

                setTimeout(() => {
                  let rotating = this.loadingCtrl.create({
                    content: this.translate.instant('rotate_image')
                  })
                  if (type == 'portrait') rotating.present()
                  setTimeout(() => {
                    if (type == 'portrait') {
                      this.cameraOrientation == 'portrait'
                      this.changeOrientation()
                      rotating.dismiss()
                    }
                  }, 800)
                }, 1000)
              })
              this.newZone()
              this.appState = this.APP_STATE_DRAWING
            })
            .then(
              snapshot => {
                // console.log('Snapshot', snapshot);
                // this.appState = this.APP_STATE_NO_PICTURE;
                // loading.dismiss();
              },
              err => {
                console.log('Image error', err)
                this.appState = this.APP_STATE_NO_PICTURE
                loading.dismiss()
              }
            )
        }
      })
      alert.present()
    }
  }

  /* --- */

  /* TUTORIAL */

  openTutorial () {
    var myModal: Modal
    myModal = this.modal.create('TutorialPage')
    myModal.present().then(() => {
      $('#zone_' + this.currentZone).css('opacity', '0')
    })

    myModal.onWillDismiss(data => {
      $('#zone_' + this.currentZone).css('opacity', '1')
    })
  }

  /* --- */

  /* SHOW HIDE CONTROLS */

  toggleControls () {
    this.showControls = !this.showControls
  }

  /* --- */

  /* GESTURES */

  rotate (e) {
    if (this.appState == this.APP_STATE_MATERIAL) {
      if (this.zones['zone_' + this.currentZone]['perspective']['x'] < 80) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        if (e.offsetDirection == 4) pz++
        else if (e.offsetDirection == 2) pz--
        this.zones['zone_' + this.currentZone]['perspective']['z'] = pz
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          '-webkit-transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)  rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg)'
        )
      }
    }
  }

  rotate90 () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      if (this.zones['zone_' + this.currentZone]['perspective']['x'] < 80) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        pz = pz + 90.0
        this.zones['zone_' + this.currentZone]['perspective']['z'] = pz
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          '-webkit-transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)  rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  rotateRight () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      if (this.zones['zone_' + this.currentZone]['perspective']['x'] < 80) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        pz = pz + 1.0
        this.zones['zone_' + this.currentZone]['perspective']['z'] = pz
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          '-webkit-transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)  rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  rotateLeft () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      if (this.zones['zone_' + this.currentZone]['perspective']['x'] < 80) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        pz = pz - 1.0
        this.zones['zone_' + this.currentZone]['perspective']['z'] = pz
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          '-webkit-transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)  rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  zoom (e) {
    // if ((this.appState == this.APP_STATE_DRAWING)){
    //   this.isZooming = true;
    //   if (e.additionalEvent == 'pinchout') {
    //     $(".background_image, .points, .points_path, .points_path_sub, .inner_shadow").css("width", "+=10");
    //     $(".background_image, .points, .points_path, .points_path_sub, .inner_shadow").css("height", "+=10");
    //   }
    //   else if (e.additionalEvent == 'pinchin') {
    //     if (parseInt($(".background_image").css("width"), 10) > window.innerWidth) {
    //       $(".background_image, .points, .points_path, .points_path_sub, .inner_shadow").css("width", "-=10");
    //       $(".background_image, .points, .points_path, .points_path_sub, .inner_shadow").css("height", "-=10");
    //     }
    //   }
    // }
  }

  zoomInPicture () {
    this.screen_zoom += 10
    $(
      '.background_image, .points, .points_path, .points_path_sub, .inner_shadow, #zone_' +
        this.currentZone
    ).css('width', this.screen_zoom + '%')
    $(
      '.background_image, .points, .points_path, .points_path_sub, .inner_shadow, #zone_' +
        this.currentZone
    ).css('height', this.screen_zoom + '%')

    // var bg = <HTMLElement>document.getElementsByClassName('background_image')[0];
    // var el = <HTMLElement>document.getElementsByClassName('scroll-content')[1];
    // $('ion-content .scroll-content').animate({
    //   scrollTop: ((bg.offsetHeight - el.offsetHeight) / 2),
    //   scrollLeft: ((bg.offsetWidth - el.offsetWidth) / 2)
    // }, 0);
  }

  zoomOutPicture () {
    if (this.screen_zoom > 100) {
      this.screen_zoom -= 10
      $(
        '.background_image, .points, .points_path, .points_path_sub, .inner_shadow, #zone_' +
          this.currentZone
      ).css('width', this.screen_zoom + '%')
      $(
        '.background_image, .points, .points_path, .points_path_sub, .inner_shadow, #zone_' +
          this.currentZone
      ).css('height', this.screen_zoom + '%')

      // var bg = <HTMLElement>document.getElementsByClassName('background_image')[0];
      // var el = <HTMLElement>document.getElementsByClassName('scroll-content')[1]
      // $('ion-content .scroll-content').animate({
      //   scrollTop: ((bg.offsetHeight - el.offsetHeight) / 2),
      //   scrollLeft: ((bg.offsetWidth - el.offsetWidth) / 2)
      // }, 0);
    }
  }

  zoomEnd (e) {
    setTimeout(() => {
      this.isZooming = false
    }, 500)
  }

  zoomIn () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      var that = this
      var z = this.zones['zone_' + this.currentZone]['zoom']
      if (z + 10 < 1200) {
        z = z + 10
        this.zones['zone_' + this.currentZone]['zoom'] = z
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'background-size',
          z + 'px'
        )
      }
    }
  }

  zoomOut () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      var that = this
      var z = this.zones['zone_' + this.currentZone]['zoom']
      if (z - 10 > 150) {
        z = z - 10
        this.zones['zone_' + this.currentZone]['zoom'] = z
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'background-size',
          z + 'px'
        )
      }
    }
  }

  resetZoom () {
    this.screen_zoom = 100
    $(' .inner_shadow')
      .css('width', 0)
      .css('height', 0)

    $(
      '.background_image, .points, .points_path, .points_path_sub, #zone_' +
        this.currentZone
    )
      .css('width', '100%')
      .css('overflow', 'hidden')

    $(
      '.background_image, .points, .points_path, .points_path_sub, #zone_' +
        this.currentZone
    )
      .css('height', '100%')
      .css('overflow', 'hidden')

    setTimeout(() => {
      $(' .inner_shadow')
        .css('width', '100%')
        .css('height', '100%')
    }, 10)
  }

  resetTransform () {
    this.zones['zone_' + this.currentZone]['perspective']['x'] = 0
    this.zones['zone_' + this.currentZone]['perspective']['y'] = 0
    this.zones['zone_' + this.currentZone]['perspective']['z'] = 0
    $('#zone_' + this.currentZone + ' .points_path .material').css(
      '-webkit-transform',
      'perspective(' +
        this.pSize.width * 5.2 +
        'px)  rotateY(' +
        0 +
        'deg) rotateX(' +
        0 +
        'deg) rotateZ(' +
        0 +
        'deg)'
    )

    this.zones['zone_' + this.currentZone]['zoom'] = window.innerWidth / 2.5
    $('#zone_' + this.currentZone + ' .points_path .material').css(
      'background-size',
      window.innerWidth / 2.5 + 'px'
    )

    this.zones['zone_' + this.currentZone]['brightness'] = 100
    $('#zone_' + this.currentZone + ' .points_path .material').css(
      'filter',
      'brightness(' + 100 + '%)'
    )
  }

  brightnessUp () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      var that = this
      var b = this.zones['zone_' + this.currentZone]['brightness']
      if (b + 1 < 140) {
        b = b + 1
        this.zones['zone_' + this.currentZone]['brightness'] = b
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'filter',
          'brightness(' + b + '%)'
        )
      }
    }
  }

  brightnessDown () {
    if (this.appState == this.APP_STATE_MATERIAL) {
      var that = this
      var b = this.zones['zone_' + this.currentZone]['brightness']
      if (b - 1 > 50) {
        b = b - 1
        this.zones['zone_' + this.currentZone]['brightness'] = b
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'filter',
          'brightness(' + b + '%)'
        )
      }
    }
  }

  fugaUp () {
    var limit = 70
    if (this.getOrientation() == 'portrait') limit = 80

    if (this.fuga < limit) {
      this.fuga = this.fuga + 0.75
      $('#zone_' + this.currentZone + ' .points_path .material').css(
        'transform-origin',
        '50% ' + this.fuga + '%'
      )
    }
  }

  fugaDown () {
    var limit = 30
    if (this.getOrientation() == 'portrait') limit = 40

    if (this.fuga > limit) {
      this.fuga = this.fuga - 0.75
      $('#zone_' + this.currentZone + ' .points_path .material').css(
        'transform-origin',
        '50% ' + this.fuga + '%'
      )
    }
  }

  fugaRight () {
    var limit = 80
    if (this.getOrientation() == 'portrait') limit = 80

    if (this.fuga < limit) {
      this.fuga = this.fuga + 0.2
      $('#zone_' + this.currentZone + ' .points_path .material').css(
        'transform-origin',
        '' + this.fuga + '% 50%'
      )
    }
  }

  fugaLeft () {
    var limit = 20
    if (this.getOrientation() == 'portrait') limit = 20

    if (this.fuga > limit) {
      this.fuga = this.fuga - 0.2
      $('#zone_' + this.currentZone + ' .points_path .material').css(
        'transform-origin',
        '' + this.fuga + '% 50%'
      )
    }
  }

  perspectiveUp () {
    if (
      this.appState == this.APP_STATE_MATERIAL &&
      this.zones['zone_' + this.currentZone].type == 'floor'
    ) {
      var limit = 75
      if (this.getOrientation() == 'portrait') limit = 38

      if (this.zones['zone_' + this.currentZone]['perspective']['x'] < limit) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        px = px + 1
        this.zones['zone_' + this.currentZone]['perspective']['x'] = px
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)' +
            'rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  perspectiveDown () {
    if (
      this.appState == this.APP_STATE_MATERIAL &&
      this.zones['zone_' + this.currentZone].type == 'floor'
    ) {
      if (this.zones['zone_' + this.currentZone]['perspective']['x'] > -40) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        px = px - 1
        this.zones['zone_' + this.currentZone]['perspective']['x'] = px
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)' +
            'rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  perspectiveRight () {
    if (
      this.appState == this.APP_STATE_MATERIAL &&
      this.zones['zone_' + this.currentZone].type == 'wall'
    ) {
      if (this.zones['zone_' + this.currentZone]['perspective']['y'] < 50) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        py = py + 1

        this.zones['zone_' + this.currentZone]['perspective']['y'] = py
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)' +
            'rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  perspectiveLeft () {
    if (
      this.appState == this.APP_STATE_MATERIAL &&
      this.zones['zone_' + this.currentZone].type == 'wall'
    ) {
      if (this.zones['zone_' + this.currentZone]['perspective']['y'] > -50) {
        var that = this
        var px = this.zones['zone_' + this.currentZone]['perspective']['x']
        var py = this.zones['zone_' + this.currentZone]['perspective']['y']
        var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
        py = py - 1

        this.zones['zone_' + this.currentZone]['perspective']['y'] = py
        $('#zone_' + that.currentZone + ' .points_path .material').css(
          'transform',
          'perspective(' +
            this.pSize.width * 5.2 +
            'px)' +
            'rotateY(' +
            py +
            'deg) rotateX(' +
            px +
            'deg) rotateZ(' +
            pz +
            'deg)'
        )
      }
    }
  }

  /* --- */

  /* ZONE */

  async newZone () {
    if (
      this.currentZone != 0 &&
      this.zones['zone_' + this.currentZone]['background'] == ''
    ) {
      if (this.appState == this.APP_STATE_DRAWING) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('alert'),
          subTitle: this.translate.instant('before_create_zone'),
          buttons: ['Ok']
        })

        alert.present()
      } else this.currentZone++
    } else {
      let currentAlert = this.alertCtrl.create({
        title: this.translate.instant('new_zone'),
        inputs: [
          {
            type: 'radio',
            label: this.translate.instant('wall'),
            value: JSON.stringify({ type: 'wall', description: 'wall' }),
            checked: true
          },
          {
            type: 'radio',
            label: this.translate.instant('floor'),
            value: JSON.stringify({ type: 'floor', description: 'floor' })
          },
          {
            type: 'radio',
            label: this.translate.instant('countertop'),
            value: JSON.stringify({ type: 'floor', description: 'countertop' })
          },
          {
            type: 'radio',
            label: this.translate.instant('facade'),
            value: JSON.stringify({ type: 'wall', description: 'facade' })
          },
          {
            type: 'radio',
            label: this.translate.instant('edge'),
            value: JSON.stringify({ type: 'wall', description: 'edge' })
          }
        ],
        buttons: [
          {
            text: this.translate.instant('cancel'),
            cssClass: 'new_zone_button'
          },
          {
            text: this.translate.instant('create'),
            cssClass: 'new_zone_button',
            handler: value => {
              var that = this

              const objectType = JSON.parse(value)

              this.currentAction = 'perspective'
              this.currentInclude = true

              this.currentZone = this.zonesCount() + 1
              this.appState = this.APP_STATE_DRAWING

              //Zona no creada todavia
              $('.scroll-zoom-wrapper').append(
                '\
                <div id="zone_' +
                  this.currentZone +
                  '" class="zone_edition" >\
                  <div class="points"></div>\
                  <div class="points_path"></div>\
                  <div class="points_path_sub"></div>\
                  <div class="inner_shadow"></div>\
                </div>'
              )

              var newZone = {
                add: [],
                sub: [],
                background: '',
                perspective: {
                  x: 0,
                  y: 0,
                  z: 0
                },
                brightness: 100,
                zoom: window.innerWidth / 2.5,
                type: objectType.type,
                description: objectType.description
              }
              this.zones['zone_' + this.currentZone] = newZone

              if (this.currentZone == 1) {
                this.layerHistory[
                  'zone_' + (this.currentZone - 1)
                ] = this.cameraPictureBase64
              }

              this.resetZoom()
              this.showClickAnimation()
            }
          }
        ],
        enableBackdropDismiss: false
      })

      await currentAlert.present()
    }
  }

  zonesCount () {
    var size = 0,
      key
    for (key in this.zones) {
      if (this.zones.hasOwnProperty(key)) size++
    }
    return size
  }

  async initialValues () {
    this.zones = {}
    this.currentZone = 0
    this.currentAction = 'perspective'
    this.currentInclude = true
    this.defaultLan = this.translate.getDefaultLang()
  }

  nextZone () {
    if (this.zones.hasOwnProperty('zone_' + (this.currentZone + 1))) {
      if (this.appState == this.APP_STATE_DRAWING) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('alert'),
          subTitle: this.translate.instant('before_create_zone'),
          buttons: ['Ok']
        })

        alert.present()
      } else this.currentZone++
    }
  }

  prevZone () {
    if (this.zones.hasOwnProperty('zone_' + (this.currentZone - 1))) {
      if (this.appState == this.APP_STATE_DRAWING) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('alert'),
          subTitle: this.translate.instant('before_create_zone'),
          buttons: ['Ok']
        })

        alert.present()
      } else {
        this.currentZone--
      }
    }
  }

  deletePoint () {
    if (this.canDeletePoint()) {
      if (this.currentInclude)
        this.zones['zone_' + this.currentZone]['add'].pop()
      else this.zones['zone_' + this.currentZone]['sub'].pop()

      $('.dot')
        .last()
        .remove()
      var path
      if (this.currentInclude) path = 'add'
      else path = 'sub'
      this.drawPath(path)
    }
  }

  deleteZone () {
    let alert = this.alertCtrl.create()
    alert.setTitle(this.translate.instant('delete_zone_question'))

    alert.addButton(this.translate.instant('cancel'))
    alert.addButton({
      text: this.translate.instant('agree'),
      handler: (type: any) => {
        this.productsList.pop()

        this.appState = this.APP_STATE_MATERIAL

        $('#zone_' + this.currentZone).remove()

        var zoneDelete = this.currentZone
        // var pointsToDelete = this.zones;

        // delete pointsToDelete['zone_' + zoneDelete];
        // let keys = [];
        // for (let key in pointsToDelete) {
        //   keys.push({ key: key, value: pointsToDelete[key] });
        // }
        // if(keys[0])
        //   this.currentZone = keys[0].key.split('_')[1];
        // else
        //   this.currentZone = 0;

        this.currentZone = this.currentZone - 1

        // this.cameraPictureBase64 = this.layerHistory['zone_' + this.currentZone]

        delete this.zones['zone_' + zoneDelete]
      }
    })
    alert.present()
  }

  canDeleteZone () {
    if (this.currentZone != 0) {
      if (this.zones['zone_' + this.currentZone].length != 0) {
        return true
      } else return false
    } else return false
  }

  canDeletePoint () {
    var result = false

    if (
      this.currentZone != 0 &&
      this.zones['zone_' + this.currentZone]['background'] == ''
    ) {
      if (this.currentInclude) {
        if (this.zones['zone_' + this.currentZone]['add'].length != 0)
          result = true
      } else {
        if (this.zones['zone_' + this.currentZone]['sub'].length != 0)
          result = true
      }
    }

    return result
  }

  drawPoints (clipX, clipY) {
    clearTimeout(this.clickIconTimeout)
    $('.iconClick').css("display", 'none')
    var that = this

    // Comprobar si el punto existe
    if (
      _.findWhere(that.zones['zone_' + that.currentZone]['add'], {
        x: clipX,
        y: clipY
      }) == undefined &&
      _.findWhere(that.zones['zone_' + that.currentZone]['sub'], {
        x: clipX,
        y: clipY
      }) == undefined
    ) {
      var index
      if (that.currentInclude) {
        index =
          that.zones['zone_' + that.currentZone]['add'].push({
            x: clipX,
            y: clipY
          }) - 1
        $('.points').append(
          '<div data-path-type="add" data-index="' +
            index +
            '" data-zone="' +
            that.currentZone +
            '" style="top: ' +
            clipY +
            '%; left: ' +
            clipX +
            '%" class="dot"><div class="dot-inside"></div></div>'
        )
      } else {
        index =
          that.zones['zone_' + that.currentZone]['sub'].push({
            x: clipX,
            y: clipY
          }) - 1
        $('.points').append(
          '<div data-path-type="sub" data-index="' +
            index +
            '" data-zone="' +
            that.currentZone +
            '" style="top: ' +
            clipY +
            '%; left: ' +
            clipX +
            '%" class="dot"><div class="dot-inside-sub"></div></div>'
        )
      }
    } else {
      $(that.pointToMove).css({
        top: clipY + '%',
        left: clipX + '%'
      })
    }

    var sel
    var pathType
    if (that.currentInclude) {
      $('#zone_' + that.currentZone + ' .points_path').css(
        'background-color',
        '#6c1d45'
      )
      sel = that.zones['zone_' + that.currentZone]['add']
      pathType =
        '#zone_' +
        that.currentZone +
        ' .points_path, #zone_' +
        that.currentZone +
        ' .inner_shadow'
    } else {
      $('#zone_' + that.currentZone + ' .points_path_sub').css(
        'background-color',
        '#e23131'
      )
      sel = that.zones['zone_' + that.currentZone]['sub']
      pathType = '#zone_' + that.currentZone + ' .points_path_sub'
    }

    var path = 'polygon('
    sel.forEach(function (p, index) {
      if (index === sel.length - 1) path += p.x + '% ' + p.y + '%'
      else path += p.x + '% ' + p.y + '%,'
    })
    path += ')'

    $(pathType).css('-webkit-clip-path', path)
    $(pathType).css('clip-path', path)
  }

  drawPath (pathType) {
    var that = this

    var sel
    if (that.currentInclude) {
      $('#zone_' + that.currentZone + ' .points_path').css(
        'background',
        '#BAE67E'
      )
      sel = that.zones['zone_' + that.currentZone]['add']
      pathType =
        '#zone_' +
        that.currentZone +
        ' .points_path, #zone_' +
        that.currentZone +
        ' .inner_shadow'
    } else {
      $('#zone_' + that.currentZone + ' .points_path_sub').css(
        'background',
        '#e23131'
      )
      sel = that.zones['zone_' + that.currentZone]['sub']
      pathType = '#zone_' + that.currentZone + ' .points_path_sub'
    }

    var path = 'polygon('
    sel.forEach(function (p, index) {
      if (index === sel.length - 1) path += p.x + '% ' + p.y + '%'
      else path += p.x + '% ' + p.y + '%,'
    })
    path += ')'

    $(pathType).css('-webkit-clip-path', path)
    $(pathType).css('clip-path', path)
  }

  invertPoints () {
    for (var zone in this.zones) {
      if (this.zones.hasOwnProperty(zone)) {
        var path = 'polygon('
        this.zones[zone]['add'].forEach((element, index) => {
          var x = element.x
          var y = element.y
          this.zones[zone]['add'][index].x = y
          this.zones[zone]['add'][index].y = x
        })
        path += ')'
        $('#' + zone + ' .points_path, #' + zone + ' .inner_shadow').css(
          '-webkit-clip-path',
          path
        )
        $('#' + zone + ' .points_path, #' + zone + ' .inner_shadow').css(
          'clip-path',
          path
        )

        this.zones[zone]['sub'].forEach((element, index) => {
          var x = element.x
          var y = element.y
          this.zones[zone]['add'][index].x = y
          this.zones[zone]['add'][index].y = x
        })
      }
    }
  }

  /* --- */

  /* PRODUCTS */

  openProducts () {
    let myModal: Modal
    myModal = this.modal.create('ProductsPage', {
      products: this.productsList,
      defaultLan: this.defaultLan
    })
    myModal.present()
  }

  /* --- */

  /* PRODUCTS */

  openDistributors () {
    if (
      !this.plt.is('ios') &&
      !this.plt.is('android') &&
      !this.plt.is('windows')
    ) {
      window.open(
        'https://cupastone-distributor.overlapp.io/?language=',
        '_blank'
      )
    }

    if (
      this.plt.is('ios') ||
      this.plt.is('android') ||
      this.plt.is('windows')
    ) {
      const browser = this.iab.create(
        'https://cupastone-distributor.overlapp.io/',
        '_blank',
        'location=no,status=no,titlebar=no,toolbar=no,clearsessioncache=yes,clearcache=yes'
      )
      browser.on('loadstart').subscribe(event => {
        if (event.url.includes('mobile/close')) {
          browser.close()
        }
      })
    }
  }

  /* --- */

  /* MATERIALS */

  selectZone () {
    let zoneSelector = this.alertCtrl.create({
      title: this.translate.instant('selectZone'),
      subTitle: this.translate.instant('selectZone_sub')
    })

    Object.keys(this.zones).forEach((zone, index) => {
      zoneSelector.addInput({
        type: 'radio',
        label:
          index +
          1 +
          ' - ' +
          this.translate.instant(this.zones[zone].description),
        value: (index + 1).toString(),
        checked: this.currentZone === index + 1 || false
      })
    })

    zoneSelector.addButton(this.translate.instant('cancel'))

    zoneSelector.addButton({
      text: this.translate.instant('select'),
      handler: (zoneIndex: any) => {
        this.currentZone = parseInt(zoneIndex)
      }
    })
    zoneSelector.present()
  }

  openModalMaterials () {
    if (this.zones['zone_' + this.currentZone]['add'].length < 3) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('alert'),
        subTitle: this.translate.instant('before_set_material'),
        buttons: ['Ok']
      })

      alert.present()
    } else {
      var myModalOptions: ModalOptions = {
        enableBackdropDismiss: false
      }

      var myModal: Modal

      var zoneType = this.zones['zone_' + this.currentZone]['description']

      myModal = this.modal.create(
        'MaterialsPage',
        //heredude
        { zoneType: zoneType },
        myModalOptions
      )
      myModal.present().then(() => {
        $('#zone_' + this.currentZone).css('opacity', '0')
      })
      myModal.onWillDismiss(data => {
        $('#zone_' + this.currentZone).css('opacity', '1')
        if (data) {
          if (this.appState === this.APP_STATE_MATERIAL) {
            this.productsList.pop()
          }
          this.productsList.push(data)
          this.showHorizontalDragIcon()
          this.setMaterial(data.image)
        }
      })
    }
  }

  pathSize (json) {
    let tmp = this.findMinMax(json.add)

    let frame = {
      height: tmp.y.max - tmp.y.min,
      width: tmp.x.max - tmp.x.min,
      topLeft: {
        x: tmp.x.min,
        y: tmp.y.min
      },
      center: {
        x: tmp.x.min + (tmp.x.max - tmp.x.min) / 2,
        y: tmp.y.min + (tmp.y.max - tmp.y.min) / 2
      }
    }

    return frame
  }

  findMinMax (arr) {
    let minY = arr[0].y,
      maxY = arr[0].y
    let minX = arr[0].x,
      maxX = arr[0].x

    for (let i = 1, len = arr.length; i < len; i++) {
      let v = arr[i].y
      minY = v < minY ? v : minY
      maxY = v > maxY ? v : maxY
    }

    for (let i = 1, len = arr.length; i < len; i++) {
      let v = arr[i].x
      minX = v < minX ? v : minX
      maxX = v > maxX ? v : maxX
    }

    return {
      x: {
        min: minX,
        max: maxX
      },
      y: {
        min: minY,
        max: maxY
      }
    }
  }

  setMaterial (image) {
    var that = this

    this.resetZoom()

    // this.fuga = 50;

    this.appState = this.APP_STATE_MATERIAL

    var bg = image

    that.zones['zone_' + that.currentZone]['background'] = bg

    $('#zone_' + that.currentZone + ' .points').remove()

    $('#zone_' + that.currentZone + ' .points_path_sub').css(
      'background-image',
      'url(' + this.cameraPictureBase64 + ')'
    )
    $('#zone_' + that.currentZone + ' .points_path_sub').addClass('image')

    $('#zone_' + that.currentZone + ' .points_path').append(
      '<div class="material"></div>'
    )

    $('#zone_' + that.currentZone + ' .points_path .material').css(
      'background-image',
      'url(' + bg + ')'
    )
    $('#zone_' + that.currentZone + ' .points_path').addClass('has_material')

    var bg_size = that.zones['zone_' + that.currentZone]['zoom']
    $('#zone_' + that.currentZone + ' .points_path .material').css(
      'background-size',
      bg_size
    )

    this.pSize = this.pathSize(that.zones['zone_' + that.currentZone])
    $('#zone_' + that.currentZone + ' .points_path .material').css(
      'width',
      this.pSize.width * 3.5 + '%'
    )
    $('#zone_' + that.currentZone + ' .points_path .material').css(
      'height',
      this.pSize.height * 3.5 + '%'
    )
    $('#zone_' + that.currentZone + ' .points_path .material').css(
      'top',
      this.pSize.topLeft.y -
        (this.pSize.height * 3.5 - this.pSize.height) / 2 +
        '%'
    )
    $('#zone_' + that.currentZone + ' .points_path .material').css(
      'left',
      this.pSize.topLeft.x -
        (this.pSize.width * 3.5 - this.pSize.width) / 2 +
        '%'
    )
    // $('#zone_' + that.currentZone + ' .points_path .material').css('transform-origin', pSize.center.x + '% ' + pSize.center.y + '%');

    var px = this.zones['zone_' + this.currentZone]['perspective']['x']
    var py = this.zones['zone_' + this.currentZone]['perspective']['y']
    var pz = this.zones['zone_' + this.currentZone]['perspective']['z']
    $('#zone_' + that.currentZone + ' .points_path .material').css(
      '-webkit-transform',
      'perspective(' +
        this.pSize.width * 5.2 +
        'px)  rotateY(' +
        py +
        'deg) rotateX(' +
        px +
        'deg) rotateZ(' +
        pz +
        'deg)'
    )

    if (that.zones['zone_' + that.currentZone].type == 'wall')
      $('#zone_' + this.currentZone + ' .points_path .material').css(
        'transform-origin',
        '50% ' + this.fuga + '%'
      )
    else
      $('#zone_' + this.currentZone + ' .points_path .material').css(
        'transform-origin',
        '' + this.fuga + '% 50%'
      )
  }

  /* --- */

  /* SAVE AND EXPORT */

  async saveImage () {
    var that = this

    this.resetZoom()

    $('#fab_box').css('opacity', '0')
    $('#show_button').css('opacity', '0')

    let loading = that.loadingCtrl.create({
      content: this.translate.instant('saving_image')
    })

    const savingImage = document.getElementById('image_to_save')
    const url = await domtoimage.toPng(savingImage)

    if (this.plt.is('android')) {
      loading.present()

      that.photoLibrary
        .requestAuthorization({ read: true, write: true })
        .then(() => {
          that.photoLibrary
            .saveImage(url, 'Overlapp')
            .then(() => {
              loading.dismiss()
              $('#fab_box').css('opacity', '1')
              $('#show_button').css('opacity', '1')
            })
            .catch(err => {
              window.alert(err)
              loading.dismiss()
              $('#fab_box').css('opacity', '1')
              $('#show_button').css('opacity', '1')
            })
        })
        .catch(err => {
          loading.dismiss()
          $('#fab_box').css('opacity', '1')
          $('#show_button').css('opacity', '1')
        })
    }

    if (this.plt.is('ios')) {
      setTimeout(() => {
        that.screenshot.save('jpg', 100, 'screenshoot').then(
          function (data) {
            loading.present()
            that.photoLibrary
              .requestAuthorization()
              .then(() => {
                that.photoLibrary
                  .saveImage('file:///' + data.filePath, 'Overlapp')
                  .then(res => {
                    loading.dismiss()
                    $('#fab_box').css('opacity', '1')
                    $('#show_button').css('opacity', '1')
                  })
              })
              .catch(err => {
                loading.dismiss()
                $('#fab_box').css('opacity', '1')
                $('#show_button').css('opacity', '1')
                alert("You don't have permission the save images")
              })
          },
          function (error) {
            $('#fab_box').css('opacity', '0')
            $('#show_button').css('opacity', '0')
            console.log(error)
          }
        )
      }, 200)
    }

    if (this.plt.is('core')) {
      loading.present()
      const link = document.createElement('a')
      document.body.appendChild(link)
      link.setAttribute('href', url)
      link.setAttribute('download', 'generatedImage.jpg')
      link.click()
      loading.dismiss()
      $('#fab_box').css('opacity', '1')
      $('#show_button').css('opacity', '1')
    }
  }

  shareImage () {
    var that = this

    this.resetZoom()

    $('ion-fab, .indicator').css('opacity', '0')

    let loading = that.loadingCtrl.create({
      content: this.translate.instant('export_image')
    })

    setTimeout(() => {
      that.screenshot.save('jpg', 100, 'screenshoot').then(
        function (data) {
          loading.present()
          that.socialSharing
            .share(null, null, 'file:///' + data.filePath, null)
            .then(() => {
              loading.dismiss()
              $('ion-fab, .indicator').css('opacity', '1')
            })
            .catch(() => {
              loading.dismiss()
              $('ion-fab, .indicator').css('opacity', '1')
            })
        },
        function (error) {
          loading.dismiss()
          $('ion-fab, .indicator').css('opacity', '1')
          console.log(error)
        }
      )
    }, 200)
  }

  /* --- */

  closeRightFab () {
    if (this.zonesCount() != 0) this.fab.close()
  }

  changeLanguage (lan) {
    this.translate.setDefaultLang(lan)
  }

  showVerticalDragIcon () {}

  showHorizontalDragIcon () {
    if (
      (this.currentAction === 'perspective' && !this.perspectiveIconShowed) ||
      (this.currentAction === 'brightness' && !this.brightnessIconShowed) ||
      (this.currentAction === 'zoom' && !this.zoomIconShowed)
    ) {
      if (this.currentAction === 'perspective') {
        this.perspectiveIconShowed = true
        if (this.zones['zone_' + this.currentZone].type == 'wall') {
          $('.iconDrag').addClass('horizontalAnimation')
        }
        if (this.zones['zone_' + this.currentZone].type == 'floor') {
          $('.iconDrag').addClass('verticalAnimation')
        }
      }
      if (this.currentAction === 'brightness') {
        this.brightnessIconShowed = true
        $('.iconDrag').addClass('verticalAnimation')
      }
      if (this.currentAction === 'zoom') {
        this.zoomIconShowed = true
        $('.iconDrag').addClass('verticalAnimation')
      }

      setTimeout(() => {
        $('.iconDrag').fadeIn()
        setTimeout(() => {
          $('.iconDrag').fadeOut(function () {
            $('.iconDrag').removeClass('verticalAnimation')
            $('.iconDrag').removeClass('horizontalAnimation')
          })
        }, 3000)
      }, 500)
    }
  }

  showClickAnimation () {
    if (!this.clickIconShowed) {
      const showInposition = function (top, left) {
          $('.iconClick').css({ top, left })
          $('.iconClick').fadeIn(function () {
            setTimeout(() => {
              $('.iconClick').fadeOut()
            }, 1000)
          })
      }


      this.clickIconTimeout = setTimeout(() => {
        showInposition('50%', '30%')
        this.clickIconTimeout = setTimeout(() => {
         showInposition('30%', '50%')
          this.clickIconTimeout= setTimeout(() => {
            showInposition('50%', '80%')
          }, 2000)
        }, 2000)
      }, 500)

      
      this.clickIconShowed = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/main.ts